import setAuthToken from "../../utils/setAuthToken";
import jwt_decode from "jwt-decode";

import {
  // GET_ERRORS,
  SET_CURRENT_USER,
  // SET_APPLICANT,
  APPLICANT_FROM_SIGN
} from "./types";
import { apllicantData, setApplicant, getApplication } from "./applicantAction";
import { flagsAction } from "./flagsAction";
import { requestDataforSelectStatement } from "./getSelectData";
import { getApplicationList } from "./applicationAction";
// import {isEmpty} from 'validation/is-empty.js';
// import {store} from '../../store';
// import {getChildrenData} from './children';
// import {loginUserSigned} from '../../api/api';

// Login - Get User Token
export const loginUser = token => (dispatch, getState) => {
  setAuthToken(token);
  // Set token to Auth header

  // Decode token to get user data
  const decoded = jwt_decode(token);
  // Set current user
  const userInfo = JSON.parse(decoded.sub);
  // console.log(decoded);

  const applicant = {
    name: userInfo.givenname,
    surname: userInfo.lastname,
    fathername: userInfo.middlename,
    rnokpp: userInfo.drfocode
  };
  dispatch(dataFromSign(applicant));

  // dispatch(getApplicationList(userInfo.drfocode));
  // dispatch(getApplication(userInfo.drfocode));

  dispatch(setCurrentUser(applicant));
  
  dispatch(requestDataforSelectStatement());
  localStorage.setItem("jwtToken", token);
  localStorage.setItem("applicant", JSON.stringify(applicant));

};

export const dataFromSign = data => {
  return {
    type: APPLICANT_FROM_SIGN,
    payload: data
  };
};

// Set logged in user
export const setCurrentUser = decoded => {
  return {
    type: SET_CURRENT_USER,
    payload: decoded
  };
};

// Log user out
export const logoutUser = () => dispatch => {
  // Remove token from localStorage
  localStorage.removeItem("jwtToken");
  localStorage.removeItem("applicant");
  localStorage.removeItem("aplication");
  localStorage.removeItem("aplicationID");
  localStorage.removeItem("agreemant");
  localStorage.removeItem("applicantList");
  localStorage.removeItem("catalog");
  localStorage.removeItem("id");
  localStorage.removeItem("f");
  localStorage.removeItem("childrenList");
  localStorage.removeItem("childrenSelect");
  //localStorage.removeItem('applicant');
  // Remove auth header for future requests
  setAuthToken(false);
  // Set current user to {} which will set isAuthenticated to false
  dispatch(setCurrentUser({}));
  dispatch(dataFromSign({}));
  dispatch(setApplicant({}));
  // localStorage.removeItem('child');
};
